// extracted by mini-css-extract-plugin
export default {"editorText":"plainTextStyles_editorText__M-1MD"};